// extracted by mini-css-extract-plugin
export var add = "_g-g";
export var bar = "_g-0";
export var brandFieldsContainer = "_g-l";
export var centered = "_g-6";
export var container = "_g-1";
export var date = "_g-f";
export var dateSpinner = "_g-i";
export var errorText = "_g-8";
export var fieldSelectionContainer = "_g-m";
export var flexOne = "_g-7";
export var icon = "_g-3";
export var iconButtonContent = "_g-5";
export var loading = "_g-2";
export var logo = "_g-4";
export var mainForm = "_g-k";
export var merchantPaidDateRange = "_g-e";
export var monospace = "_g-d";
export var section = "_g-9";
export var splitStatus = "_g-j";
export var table = "_g-a";
export var tableCell = "_g-c";
export var tableHeader = "_g-b";
export var trashIcon = "_g-h";